import { Tv, Clapperboard, MonitorSmartphone, Headphones, ShieldCheck, Zap } from "lucide-react";

export const WHATSAPP_NUMBER = "5565992884616"; // Edite com seu número real (formato: 55 + DDD + número)
export const WHATSAPP_MSG = "Olá! Vim pelo site e quero testar o IPTV.";

export const benefits = [
  { icon: Clapperboard, title: "+100.000 Conteúdos", desc: "Filmes, séries, novelas e lançamentos atualizados diariamente." , span: "md:col-span-2" },
  { icon: Tv, title: "Qualidade 4K & FHD", desc: "Imagem cristalina em todos os canais e conteúdos on-demand." },
  { icon: ShieldCheck, title: "Estabilidade Anti-Travamentos", desc: "Servidores dedicados com 99,9% de uptime. Assista sem interrupções.", highlight: true, span: "md:col-span-2" },
  { icon: MonitorSmartphone, title: "Multi-dispositivos", desc: "Smart TV, celular, TV Box, PC e tablet. Onde você estiver." },
  { icon: Headphones, title: "Suporte 24/7", desc: "Time humano pronto para te ajudar a qualquer hora." },
  { icon: Zap, title: "Ativação Imediata", desc: "Configuração em menos de 1 minuto após a confirmação." },
];

export const manifesto = [
  { n: "01", title: "Servidores Dedicados", desc: "Infraestrutura premium distribuída para entregar velocidade máxima sem buffering, mesmo em horário de pico." },
  { n: "02", title: "Atualizações Diárias", desc: "Nosso catálogo cresce todo dia. Lançamentos de cinema, temporadas completas e eventos ao vivo sempre à mão." },
  { n: "03", title: "Setup em 1 Minuto", desc: "Você recebe o acesso e um guia simples. Em instantes já está assistindo no seu aparelho favorito." },
];

export const plans = [
  {
    name: "Mensal",
    price: "29,90",
    period: "/mês",
    features: ["+100.000 conteúdos", "Qualidade FHD & 4K", "1 tela simultânea", "Suporte 24/7"],
    highlight: false,
  },
  {
    name: "Trimestral",
    price: "74,90",
    period: "/3 meses",
    features: ["Tudo do plano Mensal", "2 telas simultâneas", "Canais premium inclusos", "Prioridade no suporte", "Economia de 16%"],
    highlight: true,
    badge: "MAIS POPULAR",
  },
  {
    name: "Anual",
    price: "249,90",
    period: "/ano",
    features: ["Tudo do plano Trimestral", "3 telas simultâneas", "Acesso antecipado a lançamentos", "Melhor custo-benefício"],
    highlight: false,
  },
];

export const testimonials = [
  { name: "Rafael Souza", role: "Cliente há 8 meses", text: "Zero travamentos, mesmo assistindo futebol ao vivo. O suporte responde na hora. Recomendo demais!", rot: "-rotate-2" },
  { name: "Amanda Lima", role: "Cliente há 1 ano", text: "A qualidade 4K é impressionante e tem TUDO que eu procuro. Cancelei minha TV a cabo por causa disso.", rot: "rotate-1" },
  { name: "Carlos Mendes", role: "Cliente há 5 meses", text: "Instalei em 1 minuto na minha Smart TV. Melhor decisão, pago muito menos e tenho muito mais.", rot: "rotate-2" },
  { name: "Juliana Alves", role: "Cliente há 3 meses", text: "Assisto no celular e na TV ao mesmo tempo. Estável e barato. Atendimento nota 10.", rot: "-rotate-1" },
];

export const faqs = [
  { q: "Funciona na minha Smart TV?", a: "Sim! Somos compatíveis com Smart TVs (Samsung, LG, Android TV), TV Box, celulares, tablets e computadores." },
  { q: "Preciso de internet rápida?", a: "Recomendamos no mínimo 10 Mbps para FHD e 25 Mbps para 4K. A maioria das conexões atuais funciona perfeitamente." },
  { q: "Quanto tempo leva para ativar?", a: "A ativação é imediata após a confirmação do pagamento — normalmente em menos de 1 minuto." },
  { q: "Posso testar antes de assinar?", a: "Sim! Fale com a gente no WhatsApp e liberamos um teste para você experimentar a qualidade." },
  { q: "Tem fidelidade ou multa?", a: "Não. Você escolhe o plano que quiser e renova apenas se estiver satisfeito. Sem contratos abusivos." },
];
